/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React, { useState } from 'react';
import { NumberInput, ResultBox } from './parts';

// ---------------- BMI ----------------
export const BmiCalc = () => {
  const [w, setW] = useState(null);
  const [h, setH] = useState(null);
  const bmi = w && h ? w / Math.pow(h / 100, 2) : null;
  let tone = 'neutral';
  let interp = null;
  if (bmi !== null) {
    if (bmi < 18.5) { tone = 'warning'; interp = 'Sottopeso'; }
    else if (bmi < 25) { tone = 'good'; interp = 'Peso normale'; }
    else if (bmi < 30) { tone = 'warning'; interp = 'Sovrappeso'; }
    else { tone = 'danger'; interp = `Obesita ${bmi >= 40 ? 'grave' : bmi >= 35 ? '2° grado' : '1° grado'}`; }
  }
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <NumberInput id="bmi-w" label="Peso" unit="kg" value={w} onChange={setW} min={1} />
        <NumberInput id="bmi-h" label="Altezza" unit="cm" value={h} onChange={setH} min={30} />
      </div>
      <ResultBox value={bmi} unit="kg/m²" interpretation={interp} tone={tone} />
    </div>
  );
};

// ---------------- BSA (Mosteller) ----------------
export const BsaCalc = () => {
  const [w, setW] = useState(null);
  const [h, setH] = useState(null);
  const bsa = w && h ? Math.sqrt((h * w) / 3600) : null;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <NumberInput id="bsa-w" label="Peso" unit="kg" value={w} onChange={setW} min={1} />
        <NumberInput id="bsa-h" label="Altezza" unit="cm" value={h} onChange={setH} min={30} />
      </div>
      <ResultBox value={bsa} unit="m²" interpretation="Formula di Mosteller" tone="neutral" />
    </div>
  );
};
